import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Global unsaved-changes state. Views with editable content (flow editor,
 * component edit form, etc.) set hasUnsaved when the user has made changes
 * that are not yet saved. Used by the router guard and beforeunload to alert
 * the user before navigating away, reloading, or closing the tab.
 */
export const useUnsavedChangesStore = defineStore('unsavedChanges', () => {
  const hasUnsaved = ref(false);

  const setUnsaved = (value: boolean) => {
    hasUnsaved.value = value;
  };

  const clearUnsaved = () => {
    hasUnsaved.value = false;
  };

  return {
    hasUnsaved,
    setUnsaved,
    clearUnsaved,
  };
});
